var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "crearGeneralSolicitudBajaClientes",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c(
        "div",
        { attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-form",
                {
                  model: {
                    value: _vm.dialog,
                    callback: function($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog"
                  }
                },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("v-flex", [
                            _c(
                              "h2",
                              {
                                staticClass: "h2_title",
                                staticStyle: { "margin-top": "12px !important" }
                              },
                              [
                                _vm._v(
                                  "\n                Datos Generales\n              "
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c("br"),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.numero.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.numero.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.numero,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.numero.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.fechaCreacion.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.fechaCreacion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaCreacion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaCreacion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.usuarioCreacion.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.usuarioCreacion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.usuarioCreacion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.usuarioCreacion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.observacion.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.observacion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.observacion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.observacion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.motivoTipo.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.motivoTipo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.motivoTipo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.motivoTipo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.cliente.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.cliente.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cliente,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.cliente.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.tramo.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.tramo.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.tramo, "value", $$v)
                                  },
                                  expression: "formFields.tramo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.estado.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.estado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.estado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.estado.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.autor.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.autor.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.autor, "value", $$v)
                                  },
                                  expression: "formFields.autor.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.equiposEsperados.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.equiposEsperados.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.equiposEsperados,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.equiposEsperados.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label:
                                    _vm.formFields.perifericosEsperados.label,
                                  disabled: true
                                },
                                model: {
                                  value:
                                    _vm.formFields.perifericosEsperados.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.perifericosEsperados,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.perifericosEsperados.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.fechaCRM.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.fechaCRM.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaCRM,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaCRM.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.concepto.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.concepto.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.concepto,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.concepto.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.fechaVerifica.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.fechaVerifica.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaVerifica,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaVerifica.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.nroTramiteSim.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.nroTramiteSim.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nroTramiteSim,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nroTramiteSim.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label:
                                    _vm.formFields.dispositivosDetectados.label,
                                  disabled: true
                                },
                                model: {
                                  value:
                                    _vm.formFields.dispositivosDetectados.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.dispositivosDetectados,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.dispositivosDetectados.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.simsDetectadas.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.simsDetectadas.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.simsDetectadas,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.simsDetectadas.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.estadoTramiteSim.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.estadoTramiteSim.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.estadoTramiteSim,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.estadoTramiteSim.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }